import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SENSORS_URL } from '../Constants';
import './TextInput.css';

const TextInput = ({ title, transparentBackground, hint, draggable, pin, value, did, tid }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => setInputValue(value), [value]);

  const setGrabbing = (e, on) => {
    if (!draggable) return;
    const el = e.target.closest('.widget-container');
    if (!el) return;
    el.classList.toggle('is-grabbing', Boolean(on));
  };

  const control = (e) => {
    if (did && e.key === 'Enter') {
      const body = JSON.stringify({ device: did, template: tid, data: { [pin]: e.target.value } });
      axios
        .post(`${SENSORS_URL}/control`, body, { headers: { 'Content-Type': 'application/json' } })
        .then(() => setInputValue(e.target.value))
        .catch(() => setInputValue(value));
    } else {
      setInputValue(e.target.value);
    }
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div
      className={
        `widget-container text-input-widget ` +
        `${draggable ? 'is-draggable' : 'not-draggable'} ` +
        `${transparentBackground ? 'is-transparent' : ''}`
      }
      onMouseDown={(e) => setGrabbing(e, true)}
      onMouseUp={(e) => setGrabbing(e, false)}
      onMouseLeave={(e) => setGrabbing(e, false)}
      draggable={draggable}
      onDragStart={(e) => {
        const id = e.target.closest('.widget').id;
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.x;
        const offsetY = e.clientY - rect.y;
        let dragData = `text;${id};${offsetX};${offsetY};`;
        dragData += id.startsWith('base') ? 'add' : 'move';
        e.dataTransfer.setData('text/plain', dragData);
      }}
    >
      <h3 className="text-input-widget__title">{title}</h3>
      <input
        value={inputValue}
        placeholder={hint}
        onChange={handleInputChange}
        onKeyUp={(e) => control(e)}
        type="text"
        className="widget-input"
      />
    </div>
  );
};

export default TextInput;
